<template>
    <v-row class="pb-offset pt-4">
        <v-col class="pa-0 px-4">
            <v-card elevation="1" class="background-2 round-card">
                <v-card-title class="px-3 py-2">
                    <p class="pl-2 pl-xl-3">Configurazione Tempest</p>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-container class="pa-0" fluid>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    label="URL"
                                    v-model="tempest.options.url"
                                    :error-messages="errors.collect('URL')"
                                    v-validate="'required'"
                                    data-vv-name="URL"
                                    hint="Inserisci l'URL del servizio Tempest"
                                    persistent-hint
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                            
                            <v-col cols="12" md="6">
                                <v-text-field
                                    label="Alias"
                                    v-model="tempest.options.alias"
                                    :error-messages="errors.collect('Alias')"
                                    v-validate="'required'"
                                    data-vv-name="Alias"
                                    hint="Inserisci l'alias dell'account Tempest"
                                    persistent-hint
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                            
                            <v-col cols="12" md="6">
                                <v-text-field
                                    label="Key"
                                    v-model="tempest.options.key"
                                    :error-messages="errors.collect('Key')"
                                    v-validate="'required'"
                                    data-vv-name="Key"
                                    hint="Inserisci la chiave di accesso all'API"
                                    persistent-hint
                                    type="password"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                            
                            <v-col cols="12" md="6">
                                <v-text-field
                                    label="Gruppo ACD"
                                    v-model="tempest.options.group"
                                    hint="Gruppo a cui assegnare le chiamate uscenti, se non impostato sul singolo utente"
                                    persistent-hint
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="6" class="d-flex align-center">
                                <v-switch
                                    inset
                                    v-model="tempest.active"
                                    label="Integrazione attiva"
                                    color="primary"
                                    hint="Attiva o disattiva l'integrazione con Tempest"
                                    persistent-hint
                                ></v-switch>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                
                <v-divider></v-divider>
                
                <v-card-actions class="pa-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        @click="saveConfiguration">
                        Salva Configurazione
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
        
        <v-col class="pa-0 px-4 mt-4" cols="12">
            <v-card elevation="1" class="background-2 round-card">
                <v-card-title class="px-3 py-2">
                    <p class="pl-2 pl-xl-3">Sincronizzazione con Tempest</p>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-container class="pa-0" fluid>
                        <v-list>
                            <v-list-item>
                                <v-list-item-content class="py-2">
                                    <v-list-item-title class="font-weight-medium">Importa Campagne</v-list-item-title>
                                    <v-list-item-subtitle>
                                        Recupera tutte le campagne da Tempest e le aggiorna nel CRM
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn 
                                        color="primary" 
                                        :loading="syncingCampaigns"
                                        @click="syncCampaigns">
                                        <v-icon left>mdi-download</v-icon>
                                        Importa
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            
                            <v-divider></v-divider>
                            
                            <v-list-item>
                                <v-list-item-content class="py-2">
                                    <v-list-item-title class="font-weight-medium">Importa Utenti</v-list-item-title>
                                    <v-list-item-subtitle>
                                        Recupera tutti gli utenti da Tempest e li aggiorna nel CRM
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn 
                                        color="primary" 
                                        :loading="syncingUsersToCrm"
                                        @click="syncUsersToCrm">
                                        <v-icon left>mdi-download</v-icon>
                                        Importa
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            
                            <v-divider></v-divider>
                            
                            <v-list-item>
                                <v-list-item-content class="py-2">
                                    <v-list-item-title class="font-weight-medium">Importa Esiti</v-list-item-title>
                                    <v-list-item-subtitle>
                                        Recupera tutti i risultati delle campagne da Tempest e li aggiorna nel CRM
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn 
                                        color="primary" 
                                        :loading="syncingResults"
                                        @click="syncResults">
                                        <v-icon left>mdi-download</v-icon>
                                        Importa
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>

                            <v-divider></v-divider>

                        </v-list>
                        
                        <v-alert
                            v-if="syncStatus"
                            :type="syncStatus.type"
                            dense
                            outlined
                            class="mt-3">
                            {{ syncStatus.message }}
                        </v-alert>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-col>
        
        <v-snackbar
            :timeout="6000"
            :color="snackbarColor"
            v-model="snackbar">
            <span class="fw500">{{ snackbarText }}</span>
            <v-btn dark text @click.native="snackbar = false">Chiudi</v-btn>
        </v-snackbar>
    </v-row>
</template>

<script>
import Vue from 'vue'

export default {
    name: 'tempest',
    props: {
        id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            tempest: {
                active: false,
                options: {
                    url: '',
                    alias: '',
                    key: '',
                    group: ''
                }
            },
            snackbar: false,
            snackbarText: '',
            snackbarColor: 'success',
            loading: false,
            syncingCampaigns: false,
            syncingUsersToCrm: false,
            syncingResults: false,
            syncStatus: null
        }
    },
    
    created() {
        this.loadConfiguration();
    },
    
    methods: {
        loadConfiguration() {
            this.loading = true;
            this.axios.get('integrationsapps/' + this.id).then(response => {
                // Inizializzazione della struttura tempest
                this.tempest = response.data.data;
                
                // Assicurarsi che options esista
                if (!this.tempest.options) {
                    Vue.set(this.tempest, 'options', {
                        url: '',
                        alias: '',
                        key: '',
                        group: ''
                    });
                }

                // Vue 2 non rende reattive le chiavi aggiunte dopo: le options
                // salvate prima dell'introduzione del gruppo non lo contengono
                if (this.tempest.options.group === undefined) {
                    Vue.set(this.tempest.options, 'group', '');
                }

                this.loading = false;
                this.$store.commit('endProgress');
            }).catch(error => {
                console.error('Errore durante il caricamento della configurazione:', error);
                this.loading = false;
                this.snackbar = true;
                this.snackbarColor = 'error';
                this.snackbarText = 'Errore durante il caricamento della configurazione';
            });
        },
        
        saveConfiguration() {

            this.$validator.validateAll().then(result => {
                if (!result) {
                    return false;
                }
                
                this.loading = true;
                
                this.axios.put('integrationsapps/' + this.id, this.tempest).then(response => {
                    this.loading = false;
                    this.snackbar = true;
                    this.snackbarColor = 'success';
                    this.snackbarText = 'Configurazione salvata con successo';
                }).catch(error => {
                    console.error('Errore durante il salvataggio della configurazione:', error);
                    this.loading = false;
                    this.snackbar = true;
                    this.snackbarColor = 'error';
                    this.snackbarText = error.response?.data?.message || 'Errore durante il salvataggio della configurazione';
                });
            });
        },
        
        syncCampaigns() {
            if (!this.validateIntegration()) return;
            
            this.syncingCampaigns = true;
            this.syncStatus = { type: 'info', message: 'Avvio importazione campagne...' };
            
            this.axios.post('tempest/sync-campaigns')
                .then(response => {
                    this.syncStatus = { 
                        type: 'success', 
                        message: 'La sincronizzazione delle campagne è stata avviata correttamente. Il processo verrà completato in background.'
                    };
                })
                .catch(error => {
                    console.error('Errore durante l\'avvio della sincronizzazione delle campagne:', error);
                    this.syncStatus = { 
                        type: 'error', 
                        message: 'Errore durante l\'avvio della sincronizzazione delle campagne: ' + 
                                (error.response?.data?.message || error.message || 'Errore sconosciuto')
                    };
                })
                .finally(() => {
                    this.syncingCampaigns = false;
                });
        },
        
        syncUsersToCrm() {
            if (!this.validateIntegration()) return;
            
            this.syncingUsersToCrm = true;
            this.syncStatus = { type: 'info', message: 'Avvio importazione utenti...' };
            
            this.axios.post('tempest/sync-users-to-crm')
                .then(response => {
                    this.syncStatus = { 
                        type: 'success', 
                        message: 'La sincronizzazione degli utenti è stata avviata correttamente. Il processo verrà completato in background.'
                    };
                })
                .catch(error => {
                    console.error('Errore durante l\'avvio della sincronizzazione degli utenti:', error);
                    this.syncStatus = { 
                        type: 'error', 
                        message: 'Errore durante l\'avvio della sincronizzazione degli utenti: ' + 
                                (error.response?.data?.message || error.message || 'Errore sconosciuto')
                    };
                })
                .finally(() => {
                    this.syncingUsersToCrm = false;
                });
        },
        
        syncResults() {
            if (!this.validateIntegration()) return;
            
            this.syncingResults = true;
            this.syncStatus = { type: 'info', message: 'Avvio importazione esiti...' };
            
            this.axios.post('tempest/sync-results')
                .then(response => {
                    this.syncStatus = { 
                        type: 'success', 
                        message: 'La sincronizzazione degli esiti è stata avviata correttamente. Il processo verrà completato in background.'
                    };
                })
                .catch(error => {
                    console.error('Errore durante l\'avvio della sincronizzazione degli esiti:', error);
                    this.syncStatus = { 
                        type: 'error', 
                        message: 'Errore durante l\'avvio della sincronizzazione degli esiti: ' + 
                                (error.response?.data?.message || error.message || 'Errore sconosciuto')
                    };
                })
                .finally(() => {
                    this.syncingResults = false;
                });
        },
        
        validateIntegration() {
            if (!this.tempest.active) {
                this.syncStatus = { 
                    type: 'warning', 
                    message: 'L\'integrazione con Tempest non è attiva. Attivala e salva la configurazione prima di procedere.'
                };
                return false;
            }
            
            if (!this.tempest.options.url || !this.tempest.options.alias || !this.tempest.options.key) {
                this.syncStatus = { 
                    type: 'warning', 
                    message: 'Configurazione incompleta. Inserisci tutti i campi richiesti e salva prima di procedere.'
                };
                return false;
            }
            
            return true;
        }
    }
}
</script>
